/**
 * Share link (web_share_url) from API includes video
 * id with a timestamp separated by dot `{timestamp}.{videoId}`.
 */
export function videoIdWithoutTimestamp(videoId: string): string {
  return videoId.split('.')[1] || videoId
}
